export default __webpack_public_path__ + "static/studio-slider-20-20c1b1146d05e0e8ec595757bddcdd55.png";